import jQuery from 'jquery'
import 'slick-carousel'
import defaultSlickConfig from "./default-slick-config";

jQuery( document ).ready(()=>{
	jQuery('.custom-slick-carousel').each(function() {
		const overriddenConfig = jQuery( this ).data()
		overriddenConfig.autoplaySpeed = overriddenConfig.autoplayspeed

		let slickConfig = {
			...defaultSlickConfig,
			...overriddenConfig
		}
		console.log({defaultSlickConfig, overriddenConfig, slickConfig})
		jQuery( this ).slick(slickConfig)
	});
})
